/**
 * 后端接口权限码枚举
 *
 * API 权限码用于后端 @Permission(...) 和前端菜单 dependencies。
 * 命名格式：API_模块名_CONTROLLER方法名。
 */
export var ApiPermissionCode;
(function (ApiPermissionCode) {
    ApiPermissionCode["API_TENANT_CREATE"] = "API_TENANT_CREATE";
    ApiPermissionCode["API_TENANT_FIND_ALL"] = "API_TENANT_FIND_ALL";
    ApiPermissionCode["API_TENANT_FIND_MANY"] = "API_TENANT_FIND_MANY";
    ApiPermissionCode["API_TENANT_FIND_ONE"] = "API_TENANT_FIND_ONE";
    ApiPermissionCode["API_TENANT_UPDATE"] = "API_TENANT_UPDATE";
    ApiPermissionCode["API_TENANT_REMOVE"] = "API_TENANT_REMOVE";
    ApiPermissionCode["API_TENANT_REMOVE_MANY"] = "API_TENANT_REMOVE_MANY";
    ApiPermissionCode["API_TENANT_EXPORT_MANY"] = "API_TENANT_EXPORT_MANY";
    ApiPermissionCode["API_TENANT_ASSIGN_MENUS"] = "API_TENANT_ASSIGN_MENUS";
    ApiPermissionCode["API_TENANT_GET_MY_THIRD_PARTY_CONFIGS"] = "API_TENANT_GET_MY_THIRD_PARTY_CONFIGS";
    ApiPermissionCode["API_TENANT_GET_THIRD_PARTY_CONFIGS"] = "API_TENANT_GET_THIRD_PARTY_CONFIGS";
    ApiPermissionCode["API_TENANT_SAVE_THIRD_PARTY_CONFIG"] = "API_TENANT_SAVE_THIRD_PARTY_CONFIG";
})(ApiPermissionCode || (ApiPermissionCode = {}));
export const apiPermissionCode = ApiPermissionCode;
//# sourceMappingURL=index.js.map